import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class LatestNewsResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("LatestNewsResourcePackage");
    }
    public get assets_views_latest_news_latest_news_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/latest_news/latest_news_1x.atlas.json");
    }
    public get assets_views_latest_news_news_tooltip_background_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_background.png"];
    }
    public get assets_views_latest_news_news_tooltip_blue_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_blue.png"];
    }
    public get assets_views_latest_news_news_tooltip_blue_green_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_blue_green.png"];
    }
    public get assets_views_latest_news_news_tooltip_green_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_green.png"];
    }
    public get assets_views_latest_news_news_tooltip_pink_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_pink.png"];
    }
    public get assets_views_latest_news_news_tooltip_purple_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_purple.png"];
    }
    public get assets_views_latest_news_news_tooltip_red_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_red.png"];
    }
    public get assets_views_latest_news_news_tooltip_red2_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_red2.png"];
    }
    public get assets_views_latest_news_news_tooltip_red_purple_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_red_purple.png"];
    }
    public get assets_views_latest_news_news_tooltip_yellow_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_tooltip_yellow.png"];
    }
    public get assets_views_latest_news_news_purchasing_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_purchasing.png"];
    }
    public get assets_views_latest_news_news_raid_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_raid.png"];
    }
    public get assets_views_latest_news_news_shield_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_shield.png"];
    }
    public get assets_views_latest_news_news_steal_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_steal.png"];
    }
    public get assets_views_latest_news_news_sold_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_sold.png"];
    }
    public get assets_views_latest_news_news_visit_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_visit.png"];
    }
    public get assets_views_latest_news_news_leaderboard_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_leaderboard.png"];
    }
    public get assets_views_latest_news_news_relocate_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_relocate.png"];
    }
    public get assets_views_latest_news_news_token_fix_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_token_fix.png"];
    }
    public get assets_views_latest_news_news_token_upgrade_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_token_upgrade.png"];
    }
    public get assets_views_latest_news_news_rank_up_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["news_rank_up.png"];
    }
    public get assets_views_latest_news_diamond_green_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["diamond_green.png"];
    }
    public get assets_views_latest_news_gold_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["gold.png"];
    }
    public get assets_views_latest_news_diamond_purple_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["diamond_purple.png"];
    }
    public get assets_views_latest_news_coin_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["coin.png"];
    }
    public get assets_views_latest_news_token_png(): Texture {
        return this.assets_views_latest_news_latest_news_1x_atlas_json.textures["token.png"];
    }
    public get assets_views_latest_news_latest_news_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/latest_news/latest_news_1x.atlas.png");
    }
}

